var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgBpmDetection = function SvgBpmDetection(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 22 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M2.93 4.677c0-.678.55-1.228 1.227-1.228h2.59v-1h-2.59c-1.23 0-2.227.997-2.227 2.228v2.59h1zM20.203 4.677c0-1.23-.998-2.228-2.228-2.228h-2.59v1h2.59c.678 0 1.227.55 1.227 1.228v2.59h1z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M11.368 15.957a2.23 2.23 0 0 0 1.64-2.149v-6.54h-1v4.708l-2.248.614a1.836 1.836 0 1 0 .967 3.542zm-1.345-2.402 1.985-.542v.795c0 .553-.37 1.038-.903 1.184l-.642.175a.836.836 0 1 1-.44-1.612",
    clipRule: "evenodd"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M17.975 20.722c1.23 0 2.227-.997 2.227-2.227v-2.591h-1v2.59c0 .679-.549 1.228-1.227 1.228h-2.59v1zM4.157 19.722c-.678 0-1.227-.55-1.227-1.227v-2.591h-1v2.59c0 1.23.997 2.228 2.227 2.228h2.59v-1z"
  })));
};
export default SvgBpmDetection;